import React from 'react'
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate } from 'react-router-dom';
import AvatarPic from '../../assets/images/avtarPic.png';
import SendIcon from '@mui/icons-material/Send';

function MobileComplainDetails() {
    const navigate = useNavigate();
  return (
    <div className='mainWrapperView'>
     <div className='marginHorizontalCommon'>
      <div className="drawerWithTop">
        {/* <MobileDrawer /> */}
        <ArrowBackIcon
        className="backArrowMobil"
        onClick={() => navigate("/Complains")}
        />
        <h1>Complaints Details</h1>
      </div>
      <div className='topSpace'></div>
      <div className="famDetailsListInrMob">
        <div className="famDetailsListTo">
        <div className="detailsDiMob" onClick={() => navigate("/MobileComplainDetails")}>
          <h1>Demo text</h1>
          <div className="mobWithIco">
            <p>12/10/2024</p>
          </div>
        </div>
        </div>
        <div className="famDetailsListBot">
          <p>
            <span>Complain No:- 101</span>
          </p>
          <p>
            <span>Complaints Status: Open</span>
          </p>
        </div>
        <div className='dividerCommon' />
            <p className='descriptionComplainDetails'>
            Description Description Description Description Description Description
            </p>
        </div>
        <div className='ChatView1'>
        <div className="famDetailsListTo">
          <div className="alignfamDetailsListToPro">
            <div className="ImageViewRound">
              <img src={AvatarPic} alt='altimg'/>
            </div>
            <div className="detailsDiMob">
              <h1>Fname Lname</h1>
              <div className="mobWithIco">
                <p>11/12/2024</p>
              </div>
            </div>
          </div>
         </div>
        <div className='dividerCommon' />
        <p className='descriptionComplainDetails'>
            Description Description Description Description Description Description
            </p>
        </div>
        <div className='ChatView2'>
        <div className="famDetailsListTo textAlignEnd">
          <div className="alignfamDetailsListToPro ">
            <div className="detailsDiMob textAlignEnd">
              <h1>Fname Lname</h1>
              <div className="mobWithIco">
                <p>11/12/2024</p>
              </div>
            </div>
            <div className="ImageViewRound">
              <img src={AvatarPic} alt='altimg'/>
            </div>
          </div>
         </div>
        <div className='dividerCommon' />
        <p className='descriptionComplainDetails'>
            Description Description Description Description Description Description
            </p>
        </div>
        </div>
        <div className='chatInputBoxView'>
            <input type='text' className='chatInputBox'/>
            <SendIcon sx={{fontSize:35, color:'#005aff'}} />
        </div>
    </div>
  )
}

export default MobileComplainDetails